module.exports = __webpack_public_path__ + "img/nbus_bus.fc77f040.png";